<template>
  <el-dialog
    v-model="visible"
    append-to-body
    :before-close="closeDialog"
    class="ai-session-dialog"
    :class="{ 'is-rename': type === 'rename' }"
    :close-on-click-modal="false"
    :close-on-press-escape="!busy"
    :show-close="type === 'rename'"
    :title="type === 'rename' ? '重命名任务' : '删除任务'"
    width="480px"
    @opened="selectRenameTitle"
  >
    <el-input
      v-if="type === 'rename'"
      ref="renameInput"
      v-model="renameTitle"
      aria-label="任务名称"
      :disabled="busy"
      @keydown.enter.prevent="confirmDialog"
    />
    <p v-else class="ai-session-dialog__description">删除后，该任务将彻底移除，且无法恢复。</p>
    <template #footer>
      <el-button :disabled="busy" @click="visible = false">取消</el-button>
      <el-button
        :disabled="type === 'rename' && !renameTitle.trim()"
        :loading="busy"
        :type="type === 'rename' ? 'primary' : 'danger'"
        @click="confirmDialog"
        >{{ type === 'rename' ? '保存' : '删除' }}</el-button
      >
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  modelValue: Boolean,
  type: { type: String, default: 'rename' },
  session: { type: Object, default: null },
  busy: Boolean
})
const emits = defineEmits(['update:modelValue', 'confirm'])
const visible = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value)
})
const renameTitle = ref('')
const renameInput = ref()
watch(
  [visible, () => props.session?.sessionId, () => props.type],
  () => {
    if (visible.value) renameTitle.value = props.session?.title || ''
  },
  { immediate: true }
)
const selectRenameTitle = () => {
  if (props.type === 'rename') renameInput.value?.select()
}
const closeDialog = (done) => {
  if (!props.busy) done()
}
const confirmDialog = () => {
  const title = renameTitle.value.trim()
  if (props.busy || (props.type === 'rename' && !title)) return
  emits('confirm', title)
}
</script>

<style lang="scss" scoped>
:global(.ai-session-dialog.el-dialog) {
  max-width: calc(100% - 32px);
  padding: 0;
  border-radius: 24px;
  overflow: hidden;
  color: #242832;
}
:global(.ai-session-dialog .el-dialog__header) {
  padding: 24px;
  margin: 0;
}
:global(.ai-session-dialog .el-dialog__title) {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #242832;
}
:global(.ai-session-dialog.is-rename .el-dialog__header) {
  min-height: 80px;
  box-sizing: border-box;
}
:global(.ai-session-dialog .el-dialog__headerbtn) {
  top: 24px;
  right: 24px;
  width: 32px;
  height: 32px;
}
:global(.ai-session-dialog .el-dialog__body) {
  padding: 0 24px;
  font-size: 14px;
  line-height: 22px;
  color: #242832;
}
:global(.ai-session-dialog .el-dialog__close) {
  font-size: 20px;
}
:global(.ai-session-dialog .el-input__wrapper) {
  padding: 6px 12px;
  border-radius: 12px;
  box-shadow: 0 0 0 1px #e5e8f5 inset;
}
:global(.ai-session-dialog .el-input__inner) {
  height: 22px;
  line-height: 22px;
  color: #242832;
}
:global(.ai-session-dialog .el-dialog__footer) {
  padding: 24px;
}
:global(.ai-session-dialog .el-button) {
  height: 32px;
  padding: 4px 12px;
  border-radius: 12px;
  border-color: #e5e8f5;
  color: #242832;
  font-weight: 400;
}
:global(.ai-session-dialog .el-button + .el-button) {
  margin-left: 12px;
}
:global(.ai-session-dialog .el-button--primary) {
  border-color: #7a52f4;
  background: #7a52f4;
  color: #ffffff;
}
:global(.ai-session-dialog .el-button--danger) {
  border-color: #ff5a65;
  background: #ff5a65;
  color: #ffffff;
}
:global(.ai-session-dialog .el-button.is-disabled) {
  opacity: 0.5;
}
.ai-session-dialog__description {
  margin: 0;
}
</style>
